import { render } from "./CreateRoleUser.vue?vue&type=template&id=440e26d2"
import script from "./CreateRoleUser.vue?vue&type=script&lang=js"
export * from "./CreateRoleUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__